/**
 * Dropdown accessibility handling for desktop + touch:
 * - keyboard users can open and navigate dropdowns
 * - click/tap users can toggle menus
 */
function initDropdownAccessibility() {
  const containers = Array.from(document.querySelectorAll('header .group')).filter(
    (el) =>
      el.querySelector(':scope > .mega_dropdown') || el.querySelector(':scope > .dropdown_menu')
  );

  if (!containers.length) return;

  const setOpen = (container, isOpen) => {
    const button = container.querySelector(':scope > button.menu_item');
    container.classList.toggle('is-open', isOpen);
    if (button) {
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  };

  const closeAll = (exceptEl = null) => {
    containers.forEach((container) => {
      if (exceptEl && container === exceptEl) return;
      setOpen(container, false);
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.closest('header .group')) return;
    closeAll();
  });

  containers.forEach((container) => {
    const button = container.querySelector(':scope > button.menu_item');
    if (!button) return;

    button.setAttribute('aria-haspopup', 'true');
    button.setAttribute(
      'aria-expanded',
      container.classList.contains('is-open') ? 'true' : 'false'
    );

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const nextOpen = !container.classList.contains('is-open');
      closeAll(container);
      setOpen(container, nextOpen);
    });

    button.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown') {
        event.preventDefault();
        closeAll(container);
        setOpen(container, true);

        const firstLink = container.querySelector(
          ':scope > .mega_dropdown a, :scope > .dropdown_menu a'
        );
        if (firstLink instanceof HTMLElement) {
          firstLink.focus();
        }
      }
    });

    container.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      setOpen(container, false);
      button.focus();
    });

    container.addEventListener('focusin', () => {
      closeAll(container);
      setOpen(container, true);
    });

    container.addEventListener('focusout', () => {
      window.setTimeout(() => {
        const active = document.activeElement;
        if (active instanceof Node && !container.contains(active)) {
          setOpen(container, false);
        }
      }, 0);
    });
  });
}

document.addEventListener('DOMContentLoaded', initDropdownAccessibility);
